import React from 'react';



// import SideBar from './Components/leftSideBar/index';
// import EditorArea from './Components/MiddleScreen/index';
import connect from './connect';
import { fabric } from "fabric";
// import LeftSideBar from './leftSideBar/leftSideBar';
// import DesignerArea from './designerArea/designer';
// import RightSideBar from './rightSideBar/rightSideBar';
import "antd/dist/antd.css";
import LeftSideNavbar from '../../components/DesignerComponents/LeftSideNavbar.js';
import DesignerSettings from '../../components/DesignerComponents/LeftSideSettings';
import ImageArea from '../../components/DesignerComponents/ImageEditArea/imageArea';
import TextEditor from '../../components/DesignerComponents/ImageEditArea/textEditor';
import ImageEditor from '../../components/DesignerComponents/ImageEditArea/imageEditor';
import FormContainer from '../../components/DesignerComponents/OrderForm/container';
import NewArrivals from '../../components/products/NewArrivals';












class Designer extends React.Component {
         constructor(props) {
                 super(props);
                 console.error(props);
                 this.state = {currentDrawingWidth:0};
                 
                 this.onZoomClicked=this.onZoomClicked.bind(this);
                 this.scaleObjectsInCanvas=this.scaleObjectsInCanvas.bind(this);
                 this.handleOrientationChange=this.handleOrientationChange.bind(this);
                 this.handleCanvasSelection=this.handleCanvasSelection.bind(this);

         }
         componentDidMount(){
                setTimeout(() => {
                        this.initiateCanvas();
                        var canvas = new fabric.Canvas('tcanvas', {
                                hoverCursor: 'pointer',
                                selection: true,
                                selectionBorderColor: 'blue'
                        });
                        this.props.setCanvas(canvas);
                        this.props.setFrontCanvasJson(JSON.stringify(canvas));
                        this.props.setBackCanvasJson(JSON.stringify(canvas));
                      
                        window.addEventListener("orientationchange",()=>{this.handleOrientationChange()});
                        this.setState({currentDrawingWidth:document.getElementById('drawingArea').clientWidth});
        
                        canvas.on({
                                'selection:created':(e)=>this.handleCanvasSelection(e),
                                'selection:updated':(e)=>this.handleCanvasSelection(e),
                                'selection:cleared':(e)=>this.handleCanvasSelection(e),
                        });
                    }, 2000 );
         }

        initiateCanvas(){
                var height=document.getElementById('drawingArea').clientHeight;
                var width=document.getElementById('drawingArea').clientWidth;
                 if(!document.getElementById("tcanvas"))
                 {
                 var canvas=document.createElement("canvas");
                 canvas.setAttribute("width",width);
                 canvas.setAttribute("height",height);
                 canvas.setAttribute("id","tcanvas");
                 document.getElementById('drawingArea').appendChild(canvas);}
                }

         handleCanvasSelection(e){
                 var selectedObject=e.target;
                  if(selectedObject&&selectedObject.type==="text"){
                        document.getElementById('textEditorButton').style.visibility="visible";
                        document.getElementById('remove-selected').style.visibility="visible";
                  }
                  else if(selectedObject&&selectedObject.type==='image'){
                        document.getElementById('textEditorButton').style.visibility="hidden";
                        document.getElementById('remove-selected').style.visibility="visible";
                }
                
                else{
                        document.getElementById('textEditorButton').style.visibility="hidden";
                        document.getElementById('remove-selected').style.visibility="hidden";
                }

         }

         handleOrientationChange(e){
                 var oldHeight=document.getElementById('drawingArea').clientHeight;
                 if(this.state.currentDrawingWidth!==0){
                 this.onZoomClicked(this.state.currentDrawingWidth,oldHeight,false);
                 this.setState({currentDrawingWidth:document.getElementById('drawingArea').clientWidth});

         }

         }

        

         scaleObjectsInCanvas(width,oldWidth){
         const factor=width/oldWidth;
         //const yFactor=height/oldHeight;
//        // console.error(xFactor,yFactor);
//        // const factor=Math.max(xFactor,yFactor);
//         //console.error(factor);
         const objects=this.props.designer.drawingCanvas.getObjects();
         for(var i in objects){
                 var scaleX = objects[i].scaleX;
                 var scaleY = objects[i].scaleY;
                 //var left = objects[i].left;
                 //var top = objects[i].top;
                 var tempScaleX = scaleX * factor;
                 var tempScaleY = scaleY * factor;
//                 // var tempLeft = left * factor;
//                 // var tempTop = top * factor;
                objects[i].scaleX = tempScaleX;
                 objects[i].scaleY = tempScaleY;
                 objects[i].setCoords();
                 }       
                 return objects;             

         }




        onZoomClicked(outerWidth=0,outerHeight=0,shrink=true){

// //                var oldHeight=outerHeight;
                var oldWidth=outerWidth;
                if(outerWidth===0&&outerHeight===0){
//         //        oldHeight=document.getElementById('drawingArea').clientHeight;
                 oldWidth=document.getElementById('drawingArea').clientWidth;

         }


         if(shrink){
                 if(document.getElementById('shirtSettings')){
                 document.getElementById('shirtSettings').id = 'shirtSettingsShrink';
//                 setTimeout(()=>{document.getElementById('mobileZoomButton').style.left="3%"
//                 document.getElementById('drawingArea').style.zIndex="10"},1000)
                 }
                 else{
                 document.getElementById('shirtSettingsShrink').id = 'shirtSettings';

//                 setTimeout(()=>{document.getElementById('mobileZoomButton').style.left="40%"
//                 document.getElementById('drawingArea').style.zIndex=null},1000)
                 }
         }
                 setTimeout(()=>{
                 const height=document.getElementById('drawingArea').clientHeight;
                 const width=document.getElementById('drawingArea').clientWidth;
                 const canvas=document.createElement("canvas");
                 canvas.setAttribute("width",width);
                 canvas.setAttribute("height",height);
                 canvas.setAttribute("id","tcanvas");

                 if(!shrink) 
                 {
                 this.scaleObjectsInCanvas(width,oldWidth);
        }
                 const canvasCopy=JSON.stringify(this.props.designer.drawingCanvas);
                 document.getElementById('drawingArea').innerHTML='';
                 document.getElementById('drawingArea').appendChild(canvas);
                 var newCanvas = new fabric.Canvas('tcanvas', {
                         hoverCursor: 'pointer',
                         selection: true,
                         selectionBorderColor: 'blue'
                 });
                 newCanvas.on({
                        'selection:created':(e)=>this.handleCanvasSelection(e),
                        'selection:updated':(e)=>this.handleCanvasSelection(e),
                        'selection:cleared':(e)=>this.handleCanvasSelection(e),
                });
                 this.props.setCanvas(newCanvas);
                
                 this.props.designer.drawingCanvas.clear();
                 this.props.designer.drawingCanvas.loadFromJSON(canvasCopy);
                 this.setState({currentDrawingWidth:document.getElementById('drawingArea').clientWidth});
         },1000)
        }
        
        render() { 

                return<React.Fragment>

                <div  id='designerContainer' >
          <div id="orderTotalBar">
                      <span id="totalWord" >
                        Order Total
                      </span>
                      <span id="priceTag" >
                              EGP {this.props.designer.price}
                      </span>
                    </div>
          
            <div id="opertaionsContainer" className="row no-gutters">
              <div className="col-1 col-sm-1 col-md-1 col-lg-1" style={{backgroundColor:"#001529",height:'100%'}}>
                      <LeftSideNavbar props={this.props} />
              </div>
              <div className="col-1 col-sm-5 col-md-3 col-lg-3" style={{height:'100%' ,opacity:'1',zIndex:'-1'}}>
              </div>  
              <div className="col-10 col-sm-6 col-md-5 col-lg-5" style={{height:'100%'}}>
                      <ImageEditor props={this.props}/> 
                      <TextEditor  props={this.props}/>
                      <ImageArea props={this.props}/>

              </div>
              
              {/* <div className="col-0 col-sm-0 col-md-5 col-lg-5 ">
              <DesignerSettings onZoomClicked={this.onZoomClicked} props={this.props}/>

              </div> */}
              

            <div id='shirtSettingsShrink'  >
                <DesignerSettings onZoomClicked={this.onZoomClicked} props={this.props}/>
              </div>

              
              

            </div>
                {/* <div id="designerContainer">
                        <div id="slider" className="row no-gutters">
                                <div id="leftSideBar" className=" col-md-6 col-lg-3">
                                        <LeftSideBar props={this.props}/>
                                        
                                </div>

                                <div id="designerWidthExpand" className=" col-md-6 col-lg-6" style={{background:"white"}}>
                                        <DesignerArea onZoomClicked={this.onZoomClicked} props={this.props}/>
                                       
                                </div>
                                <div  className="col-md-6 col-lg-3" style={{height:"500px",border:"1px solid black"}}>
                                         <RightSideBar props={this.props}/>
                                </div>
                        </div>

                        </div> */}
                        <FormContainer props={this.props}/>
                        </div>
                
                {/* // return <div className="container">
                // <section id="typography">
                // <div className="row">
                // <div className="col">
                // <div className="span3">
                // <SideBar props={this.props} canvasRef={this.canvas} />
                // </div>
                // <div className="span6">
                // <EditorArea props={this.props} canvasRef={this.canvas}/>
                // </div>
                // </div>
                // </div>
                // </section>
                // </div>   */}
                                                  <div className="products">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  <div className="section_title text-center">
                    New Arrivals
                  </div>
                </div>
              </div>
                {/* <Product props={this.props}/> */}
                <NewArrivals props={this.props}/>
            </div>
          </div>
                </React.Fragment>
        }
}
export default connect(Designer);
;